import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { Auth } from '@jg/auth';
import { ERROR_MESSAGES } from '../../consts';
import config from '../../config';
import { IAppState } from '../../types/state.d';
import { getTeamGuid } from '../../selectors/apiSelectors';
import { locksSelector } from '../../selectors/locksSelectors';
import { generateAuthHeaders } from '../../utils';
import TeamLockTypes from '../../consts/lockTypes';
import {
  updateLocksRequestMade,
  updateLocksRequestError,
  updateLocksRequestSuccess,
} from '../actionCreators/apiActions';

const updateTeamLocks = (lockType: TeamLockTypes) => async (
  dispatch: ThunkDispatch<IAppState, Auth, Action>,
  getState: () => IAppState,
  auth: Auth,
) => {
  try {
    await auth.refreshAccessTokenIfExpired();
    dispatch(updateLocksRequestMade());
    const state = getState();
    const teamGuid = getTeamGuid(state);
    const teamLocks = locksSelector(state);

    const newLocks: { id: string; type: string }[] =
      lockType === 'charity' || lockType === 'event'
        ? teamLocks.filter(el => el.type !== lockType)
        : [];

    const response = await makeRequest(
      `${config.pagesAPI}v1/teams/${teamGuid}/locking/locks`,
      {
        method: 'PUT',
        body: JSON.stringify(newLocks),
        extraHeaders: generateAuthHeaders(auth),
      },
    );

    if (response && !response.ok) {
      throw new Error(ERROR_MESSAGES.UPDATE_LOCK_ERROR);
    }

    dispatch(updateLocksRequestSuccess({ locks: newLocks }));
  } catch (error) {
    dispatch(updateLocksRequestError());
    throw error;
  }
};

export default updateTeamLocks;
